import * as Yup from 'yup';

import { phoneNumber, validateCheckoutAmount } from 'utils/validation';

import { CheckFormValues } from './types';

export const initialValues: CheckFormValues = {
  amount: '',
  holderName: '',
  checkNumber: '',
  phoneNumber: '',
  driverLicense: '',
};

export const getValidationSchema = (amount: number) =>
  Yup.object().shape({
    checkNumber: Yup.number().required(),
    amount: validateCheckoutAmount(amount),
    driverLicense: Yup.string().required(),
    phoneNumber: phoneNumber('phoneNumber'),
    holderName: Yup.string().min(3).required(),
  });
